import { container } from 'tsyringe';
import { CampaignService } from '@/core/campaign/services/CampaignService';
import type { CurrentUser } from '@/core/user/models/CurrentUser';
import { ImportCampaignDTO } from '../DTO/ImportCampaignDTO';

export const importCampaignUseCase = async (input: ImportCampaignDTO, user: CurrentUser): Promise<void> => {
  const campaignService = container.resolve<CampaignService>('CampaignService');

  await campaignService.importCampaign(input, user);
};
